const items = [
  { icon: "ri-shield-check-line", title: "18+ 内容分级", desc: "仅面向成年用户开放浏览" },
  { icon: "ri-hd-line", title: "高清画质收录", desc: "画质与音轨信息完整标注" },
  { icon: "ri-bookmark-3-line", title: "本地收藏", desc: "无需登录，随看随存" },
  { icon: "ri-alert-line", title: "演示站点", desc: "播放区域为界面示意" },
];

export default function NoticeStrip() {
  return (
    <section className="px-4 md:px-8 lg:px-12">
      <div className="rounded-lg bg-background-200/35 border border-background-200/70 px-4 md:px-6 py-4">
        <ul className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {items.map((item) => (
            <li key={item.title} className="flex items-center gap-2.5 min-w-0">
              <span className="w-8 h-8 rounded-sm bg-background-100 text-accent-400 flex items-center justify-center shrink-0">
                <i className={item.icon} />
              </span>
              <span className="min-w-0">
                <span className="block text-xs text-foreground-100 truncate">{item.title}</span>
                <span className="block text-[11px] text-foreground-500 truncate">{item.desc}</span>
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}